/**
 * Mobile Hover Funktion
 *
 *Es wird beim touch auf ein Menüpunkt die Klasse "hover" vergeben. Klickt man außerhalb von diesem Element, wird die
 *  Klasse wieder entfernt.
 *
 * Events: document.ready
 *
 * @param selector jquery Selector für den Hover
 * @return {undefined}
 */
function nc_initAddTouchHover(selector) {
    var moduleLogger = LoggerManager.get('touch-hover').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('INIT START');
    $(document).ready(function () {
        nc_addTouchHover(selector);
    });
    moduleLogger.info('INIT ENDE');
}


/**
 * @see nc_initAddTouchHover
 */
function nc_addTouchHover(selector) {
    var moduleLogger = LoggerManager.get('touch-hover').setPrefix('Selektor: ' + selector);
    moduleLogger.trace('SCRIPT START');

    // Wenn das li in der ersten Ebene im selector ein ul beinhaltet, und das li nicht die Klasse hover hat, dann wird diese hinzugefügt. Alle anderen hover Klassen werden entfernt.
    // Click Eventad
    moduleLogger.trace('Touch-Events registrieren', $(selector + '>li').has('ul'));
    $(selector + '>li').has('ul').on('touchstart', function (e) {
        moduleLogger.info('Touch Start');
        if ($(this).hasClass('hover')) {
            moduleLogger.info('Hat bereits die Klasse hover, Klick ausführen', $(this));
            return true;
        } else {
            moduleLogger.info('Hover Klasse hinzufügen und woanders entfernen', $(this));
            $(this).addClass('hover');
            $(this).siblings().removeClass('hover');
            e.preventDefault();
            return false; //extra, and to make sure the function has consistent return points
        }
    });

    // Hover Klasse wird entfernt, wenn man außerhalb des Elements touched.
    $(document).on('touchstart', function (e) {
        if ($(e.target).is(selector + '>li.hover *') === false) {
            moduleLogger.info('Woanders getouched, Überall hover Klasse entfernen', $(e.target));
            $(selector + '>li.hover').removeClass('hover');
        }
    });
    moduleLogger.info('SCRIPT ENDE');

}